module.exports = __webpack_public_path__ + "img/like-disabled.225b16b9.svg";